/* Coco 9 — Occasion switching + complimentary card block.
 *
 * Loaded on every product page; a complete no-op unless the page rendered
 * an occasion data island. Never throws — personalisation must not break
 * add-to-cart.
 *
 * Active-occasion priority (customizable products):
 *   1. ?occasion= URL param   (applied here, on top of SSR)
 *   2. collection context      (already resolved server-side)
 *   3. product default         (already resolved server-side)
 *   4. first presentation      (already resolved server-side)
 *
 * "Write my own" (__custom__): a synthetic chip, present only when the
 * product has gift_settings.custom_insert. Selecting it swaps to the neutral
 * image, hides the occasion card preview, reveals the box-insert text field
 * and enables it (a real occasion disables + hides it again, so only one
 * personalisation ever submits). Printed-insert boxes (that flag) have no
 * separate included card, so their card preview stays hidden entirely.
 *
 * A presentation with no hero/title (e.g. the shared "No occasion" option)
 * falls back to the product's neutral image + master title, so selecting it
 * shows the plain product rather than leaving the previous chip's photo up.
 */
(function(){
  'use strict';
  var $ = function(s, r){ return (r||document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
  function setVal(el, v){ if(el) el.value = (v == null ? '' : v); }

  // ── Customizable: occasion selector ──────────────────────────────
  (function(){
    var island = $('[data-oc-data]');
    if(!island) return;
    var data;
    try { data = JSON.parse(island.textContent); } catch(e){ return; }
    if(!data || !data.presentations) return;

    var map = {};
    data.presentations.forEach(function(p){ map[p.key] = p; });

    var heroImg  = $('[data-gallery-main]');
    var titleEl  = $('[data-oc-title]');
    var subEl    = $('[data-oc-subtitle]');
    var chips    = $$('[data-oc-chip]');
    var cpImg    = $('[data-oc-cardpreview-img]');
    var cpTitle  = $('[data-oc-cardpreview-title]');
    var pkgEl    = $('[data-oc-pkg]');
    var propLabel= $('[data-oc-prop-label]');
    var propKey  = $('[data-oc-prop-key]');
    var propImg  = $('[data-oc-prop-image]');
    var propPkg  = $('[data-oc-prop-pkg]');

    var root        = $('[data-oc-root]');
    var cardPreview = $('[data-oc-cardpreview]');
    var customWrap  = $('[data-oc-custom-insert]');
    var insertInput = $('[data-oc-insert-input]');
    var insertCount = $('[data-oc-insert-count]');
    var masterTitle = root ? (root.getAttribute('data-oc-master') || '') : '';
    var neutralImg  = root ? (root.getAttribute('data-oc-neutral') || '') : '';
    // Printed-insert boxes (custom_insert flag → the insert field exists) have no
    // separate included card, so the "Included card" preview never applies to them.
    var hasCard = !customWrap;
    if(cardPreview && !hasCard){ cardPreview.style.display = 'none'; }

    function setCustomUI(on){
      if(customWrap){ customWrap.hidden = !on; customWrap.style.display = on ? '' : 'none'; }
      if(insertInput){ insertInput.disabled = !on; }
      if(cardPreview){ cardPreview.style.display = (on || !hasCard) ? 'none' : ''; }
      if(propPkg){ propPkg.disabled = on; }
    }

    function applyCustom(pushUrl){
      if(heroImg && neutralImg){ heroImg.removeAttribute('srcset'); heroImg.removeAttribute('sizes'); heroImg.src = neutralImg; heroImg.alt = masterTitle; }
      if(titleEl && masterTitle){ titleEl.textContent = masterTitle; }
      if(subEl){ subEl.textContent = 'Add your own message to the box insert.'; subEl.hidden = false; }
      chips.forEach(function(c){ c.setAttribute('aria-pressed', c.getAttribute('data-oc-key') === '__custom__' ? 'true' : 'false'); });
      setCustomUI(true);
      setVal(propLabel, 'Personalised');
      setVal(propKey, 'custom');
      setVal(propImg, neutralImg || '');
      setVal(propPkg, '');
      if(pushUrl){
        try { var u = new URL(window.location.href); u.searchParams.set('occasion', 'custom'); history.replaceState(null, '', u); } catch(e){}
      }
    }

    function apply(key, pushUrl){
      if(key === '__custom__'){ applyCustom(pushUrl); return; }
      var d = map[key];
      if(!d) return;
      setCustomUI(false);
      // Fall back to the product's neutral image + master title when a
      // presentation carries no hero/title (the shared "No occasion" option),
      // so selecting it shows the plain product instead of the last chip's photo.
      if(heroImg){ heroImg.removeAttribute('srcset'); heroImg.removeAttribute('sizes'); heroImg.src = d.hero || neutralImg || heroImg.src; heroImg.alt = d.title || masterTitle; }
      if(titleEl){ titleEl.textContent = d.title || masterTitle; }
      if(subEl){ subEl.textContent = d.subtitle || ''; subEl.hidden = !d.subtitle; }
      chips.forEach(function(c){ c.setAttribute('aria-pressed', c.getAttribute('data-oc-key') === key ? 'true' : 'false'); });
      if(cpImg && d.card){ cpImg.src = d.card; }
      if(cpTitle){ cpTitle.textContent = d.label || ''; }
      if(pkgEl){ pkgEl.textContent = d.packaging || ''; }
      setVal(propLabel, d.label);
      setVal(propKey, key);
      setVal(propImg, d.hero || d.card || neutralImg || '');
      setVal(propPkg, d.packaging);
      if(pushUrl){
        try { var u = new URL(window.location.href); u.searchParams.set('occasion', key); history.replaceState(null, '', u); } catch(e){}
      }
    }

    chips.forEach(function(c){
      c.addEventListener('click', function(){ apply(c.getAttribute('data-oc-key'), true); });
    });

    if(insertInput){
      insertInput.addEventListener('input', function(){ if(insertCount) insertCount.textContent = insertInput.value.length; });
    }

    var ssrActive = island.getAttribute('data-oc-active') || '';
    var urlKey = '';
    try { urlKey = new URL(window.location.href).searchParams.get('occasion') || ''; } catch(e){}
    if(urlKey === 'custom' && customWrap){
      apply('__custom__', false);
    } else {
      var initKey = (urlKey && map[urlKey]) ? urlKey : ssrActive;
      if(initKey && map[initKey]){ apply(initKey, false); }
    }
  })();

  // ── Universal: complimentary card block ──────────────────────
  (function(){
    var block = $('[data-oc-cardblock]');
    if(!block) return;
    var toggle = $('[data-oc-cardtoggle]', block);
    var fields = $('[data-oc-cardfields]', block);
    var occSel = $('[data-oc-cardocc]', block);
    var designsWrap = $('[data-oc-designs]', block);
    var designProp = $('[data-oc-design-prop]', block);
    var cardsIsland = $('[data-oc-cards]', block);
    var cards = {};
    if(cardsIsland){ try { cards = JSON.parse(cardsIsland.textContent) || {}; } catch(e){ cards = {}; } }

    function setDisabled(dis){
      if(!fields) return;
      $$('[name^="properties"]', fields).forEach(function(el){ el.disabled = dis; });
    }
    function reveal(){
      var on = !!(toggle && toggle.checked);
      if(fields){ fields.hidden = !on; }
      setDisabled(!on);
    }
    if(toggle){ toggle.addEventListener('change', reveal); }

    function renderDesigns(occKey){
      if(!designsWrap) return;
      var list = cards[occKey] || [];
      designsWrap.innerHTML = '';
      setVal(designProp, '');
      if(!list.length){ designsWrap.setAttribute('hidden', ''); return; }
      designsWrap.removeAttribute('hidden');
      list.forEach(function(card, i){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'oc-design';
        b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        b.innerHTML = (card.img ? '<img src="' + card.img + '" alt="" loading="lazy">' : '') + '<span>' + (card.title || '') + '</span>';
        b.addEventListener('click', function(){
          $$('.oc-design', designsWrap).forEach(function(x){ x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          setVal(designProp, card.title || '');
        });
        designsWrap.appendChild(b);
      });
      setVal(designProp, list[0].title || '');
    }

    if(occSel){
      occSel.addEventListener('change', function(){ renderDesigns(occSel.value); });
      renderDesigns(occSel.value);
    }
    reveal();
  })();
})();
